import { createHttpLink as _createHttpLink } from 'apollo-link-http'

const createHttpLink = _createHttpLink({
  uri: process.env.REACT_APP_THUNDR_SERVERLESS_URL,
})

export default createHttpLink
